import {config} from "@/config";

export const getApiUrl = (url: string): string => config("APP_API_URL") + url;
export const getAuthApiUrl = (url: string): string => config("APP_AUTH_API_URL") + url;
export const isDevelopmentEnv: boolean = config("APP_MODE") === 'development';
export const getBaseDomain = config("APP_DOMAIN");
export const getRootUrl = config("APP_ROOT_URL");
